
export function flatObject(obj) {
  let flat = {}
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === "object") {
        flat = { ...flat, ...flatObject(obj[key]) };
      } else {
        flat[key] = obj[key];
      }
    }
  }
  return flat;
}


export function flatObjectAll(obj) {
  let flat = {}
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const { zh = undefined, en = undefined } = obj[key];
      if (typeof obj[key] === "object" && zh === undefined && en === undefined) {
        flat = { ...flat, ...flatObjectAll(obj[key]) };
      } else {
        flat[key] = obj[key];
      }
    }
  }
  return flat;
}


